import styled from 'styled-components';
import OnbD from '../OnbD';
import IcoW01 from '../IcoW01';
import { Typ30 } from '../Typ';
import CarNav01 from '../CarNav01';
import Btn020 from '../Btn020';
import Btn022 from '../Btn022';
import Btn022B from '../Btn022B';

export const Wrapper = styled(OnbD)``;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
`;

export const Icon = styled(IcoW01)``;

export const Title = styled(Typ30)`
  color: #fff;
  display: block;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  width: 80%;
  white-space: pre;
`;

export const Text = styled(Typ30)`
  color: #fff;
  display: block;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  width: 80%;
  margin-bottom: 8px;
  > span {
    color: #fff;
    font-size: 18px;
  }
`;

export const Dots = styled(CarNav01)``;

export const ButtonWrapper = styled.div`
  z-index: 1;
  position: relative;
  top: -8px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 12px;
`;

type BackButtonProps = {
  $hide?: boolean;
};

export const BackButton = styled(Btn022)<BackButtonProps>`
  visibility: ${props => (props.$hide ? 'hidden' : 'visible')};
`;

type ForwardButtonProps = {
  $hide?: boolean;
};

export const ForwardButton = styled(Btn022B)<ForwardButtonProps>`
  visibility: ${props => (props.$hide ? 'hidden' : 'visible')};
  span {
    font-size: 14px;
    line-height: 24px;
    font-weight: normal;
    text-transform: uppercase;
    margin: 0;
  }
`;

type FinishButtonProps = {
  $hide?: boolean;
};

export const FinishButton = styled(Btn020)<FinishButtonProps>`
  visibility: ${props => (props.$hide ? 'hidden' : 'visible')};
  span {
    color: #fff;
  }
  &:hover {
    background-color: rgba(255, 255, 255, 0.12);
  }
`;
